import { render, staticRenderFns } from "./AtraparPokemon.vue?vue&type=template&id=e3b468c2&"
import script from "./AtraparPokemon.vue?vue&type=script&lang=js&"
export * from "./AtraparPokemon.vue?vue&type=script&lang=js&"
import style0 from "./AtraparPokemon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports